import { Award, Wrench, Sparkles, ShieldCheck } from "lucide-react";

const features = [
  {
    icon: Award,
    title: "Évtizedes szakértelem",
    description: "Évtizedes szakértelemmel dolgozunk, amit kevés vállalkozás mondhat el magáról.",
    number: "01",
  },
  {
    icon: Wrench,
    title: "Mesterségbeli tudás",
    description: "A vályogépítészet mesterei vagyunk, nem csak értünk hozzá!",
    number: "02",
  },
  {
    icon: Sparkles,
    title: "Prémium minőség",
    description: "Minden projektet prémium minőségben, szigorú precizitással vállalunk.",
    number: "03",
  },
  {
    icon: ShieldCheck,
    title: "Fenntartható otthonok",
    description: "A természetes, egészséges és fenntartható otthonok terén mi diktálunk.",
    number: "04",
  },
];

const FeaturesSection = () => {
  return (
    <section
      data-testid="features-section"
      className="py-20 md:py-32 bg-white overflow-hidden"
    >
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 bg-blue-50 text-blue-900 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              MIÉRT A VÁLYOG MESTER?
            </div>
            <h2
              className="text-3xl md:text-5xl font-extrabold tracking-tight text-slate-900"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              A kiváló csapat fogalma
            </h2>
          </div>
          <p className="text-slate-600 text-lg max-w-md lg:text-right">
            Cégünk a hagyományos vályogépítés mesterségét ötvözi a modern kivitelezés pontosságával.
          </p>
        </div>

        {/* Feature Cards - Horizontal Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              data-testid={`feature-card-${index}`}
              className="group relative bg-gradient-to-br from-slate-50 to-white p-8 rounded-3xl border border-slate-100 hover:border-blue-200 hover:shadow-xl transition-all duration-500"
            >
              {/* Large Number Background */}
              <div 
                className="absolute top-4 right-4 text-8xl font-extrabold text-slate-100 group-hover:text-blue-100 transition-colors select-none"
                style={{ fontFamily: "'Manrope', sans-serif" }}
              >
                {feature.number}
              </div>
              
              {/* Content */}
              <div className="relative z-10">
                <div className="w-14 h-14 bg-blue-900 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                  <feature.icon className="w-7 h-7 text-white" strokeWidth={1.5} />
                </div>
                
                <h3
                  className="text-2xl font-bold text-slate-900 mb-3"
                  style={{ fontFamily: "'Manrope', sans-serif" }}
                >
                  {feature.title}
                </h3>
                
                <p className="text-slate-600 leading-relaxed text-lg">
                  {feature.description}
                </p>
              </div>

              {/* Bottom Accent Line */}
              <div className="absolute bottom-0 left-8 right-8 h-1 bg-gradient-to-r from-blue-900 to-blue-500 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </div>
          ))}
        </div>

        {/* Bottom Stats Bar */}
        <div className="mt-16 bg-blue-900 rounded-3xl p-8 md:p-12">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div 
                className="text-4xl md:text-5xl font-extrabold text-white mb-2"
                style={{ fontFamily: "'Manrope', sans-serif" }}
              >
                20+
              </div>
              <div className="text-blue-200 font-medium">Év tapasztalat</div>
            </div>
            <div>
              <div 
                className="text-4xl md:text-5xl font-extrabold text-white mb-2"
                style={{ fontFamily: "'Manrope', sans-serif" }}
              >
                145+
              </div>
              <div className="text-blue-200 font-medium">Projekt</div>
            </div>
            <div>
              <div 
                className="text-4xl md:text-5xl font-extrabold text-white mb-2"
                style={{ fontFamily: "'Manrope', sans-serif" }}
              >
                98%
              </div>
              <div className="text-blue-200 font-medium">Elégedettség</div>
            </div>
            <div>
              <div 
                className="text-4xl md:text-5xl font-extrabold text-white mb-2"
                style={{ fontFamily: "'Manrope', sans-serif" }}
              >
                100%
              </div>
              <div className="text-blue-200 font-medium">Garancia</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
